import { render, staticRenderFns } from "./Related.z24.vue?vue&type=template&id=1e5c19ac"
import script from "./Related.z24.vue?vue&type=script&lang=js"
export * from "./Related.z24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports